export type ConsentCategories = {
  necessary: true;
  analytics: boolean;
  marketing: boolean;
};

export const DEFAULT_CONSENT: ConsentCategories = {
  necessary: true,
  analytics: false,
  marketing: false,
};

const STORAGE_KEY = "cookie_consent_v2";

// Read categories and decision together so the first render reflects the saved
// choice. Malformed or inaccessible storage is not a recorded decision.
export function loadConsentState(): {
  consent: ConsentCategories;
  isDecided: boolean;
} {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const saved = raw ? JSON.parse(raw) : null;
    if (
      saved?.necessary === true &&
      (saved.expires_at === undefined ||
        (typeof saved.expires_at === "number" &&
          saved.expires_at > Date.now())) &&
      typeof saved.analytics === "boolean" &&
      typeof saved.marketing === "boolean"
    ) {
      return {
        consent: {
          necessary: true,
          analytics: saved.analytics,
          marketing: saved.marketing,
        },
        isDecided: true,
      };
    }
  } catch {
    /* Use the existing defaults when storage cannot be read. */
  }
  return { consent: DEFAULT_CONSENT, isDecided: false };
}

export function loadConsent(): ConsentCategories {
  return loadConsentState().consent;
}

export function saveConsent(consent: ConsentCategories) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
  } catch {
    /* The in-memory choice still applies when storage is blocked. */
  }
  try {
    document.cookie = `cookie_consent=${encodeURIComponent(
      JSON.stringify(consent),
    )}; Path=/; Max-Age=${60 * 60 * 24 * 365}; SameSite=Lax`;
  } catch {
    /* Browsers may disable cookies. */
  }
}
